/**
 * Returns true if the given notification is a meeting notification.
 *
 * @param {object} notification The notification object to check.
 * @returns {boolean} Returns true if the notification is a meeting notification, false otherwise.
 */
export function isMeetingNotification(notif) {
    return !!notif.content?.data?.meetingId;
}
